import classNames from "classnames"
import { formatRelativeTime } from "@nova/format"
import { Comment } from "@nova/schemas"
import { ProfilePhoto } from "features/data-management/workspace/workspace/body/settings-and-collaborators/profile/ProfilePhoto"
import { useFullnameForUserId } from "features/data-management/users/storage"
import { CommentBody } from "./CommentBody"
import { AddReactionButton, useCommentReactions } from "./CommentReactions"
import { CommentMoreMenu } from "./CommentMoreMenu"

export const MapCommentThreadCard = ({
    comment,
    mapEntityId,
    showAuthor = true,
    showMoreMenu = true,
    onDelete,
}: {
    comment: Comment<"map-pin" | "map-comment">
    mapEntityId: string
    showAuthor?: boolean
    showMoreMenu?: boolean
    onDelete?: () => void
}) => {
    const { fullName } = useFullnameForUserId(comment.createdBy)
    const { pickerOpen, setPickerOpen, addButtonInHeader } = useCommentReactions(comment)

    const moreMenu = showMoreMenu && (
        <CommentMoreMenu comment={comment} mapEntityId={mapEntityId} onDelete={onDelete} />
    )

    return (
        <div className="group/comment relative flex flex-col gap-2 px-2 w-full">
            {showAuthor ? (
                <div className="flex items-start gap-3">
                    <div className="h-8 w-8 shrink-0">
                        <ProfilePhoto
                            userId={comment.createdBy}
                            fullName={fullName || ""}
                            className="rounded-lg"
                        />
                    </div>
                    <div className="flex flex-col min-w-0 grow">
                        <h5 className="text-white truncate">{fullName}</h5>
                        <small className="text-gray-300">
                            {formatRelativeTime(comment.createdAt)}
                        </small>
                    </div>
                    {moreMenu && (
                        <div
                            className="invisible group-hover/comment:visible"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {moreMenu}
                        </div>
                    )}
                </div>
            ) : (
                <div
                    className={classNames(
                        "absolute top-0 right-2 flex flex-wrap items-center justify-end gap-1",
                        !pickerOpen && "invisible group-hover/comment:visible"
                    )}
                    onClick={(e) => e.stopPropagation()}
                >
                    {addButtonInHeader && (
                        <AddReactionButton comment={comment} onOpenChange={setPickerOpen} />
                    )}
                    {moreMenu}
                </div>
            )}
            <CommentBody comment={comment} onPickerOpenChange={setPickerOpen} />
        </div>
    )
}
